/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Hook для реагирования на изменения ref объекта
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import { Ref, useCallback, useState } from 'react';

/**
 * @see https://reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node
 */
function useClientRect<T>(): [T | null, Ref<T>] {
    // @ts-ignore
    const [rect, setRect] = useState<T>(null);
    const ref = useCallback(node => {
        if (node !== null) {
            setRect(node);
        }
    }, []);
    return [rect, ref];
}

export default useClientRect;
